import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_PROJECTITEMTEMPLATES_LOAD,
    ACTION_PROJECTITEMTEMPLATES_LOAD_BY_ID,

    ACTION_PROJECTITEMTEMPLATES_SAVE,

    ACTION_PROJECTITEMTEMPLATES_CREATE,

    ACTION_PROJECTITEMTEMPLATES_VALIDATE,

    IProjectItemTemplateLoadAction,
    IProjectItemTemplateLoadByIdAction,
    IProjectItemTemplateLoadFailureAction,
    IProjectItemTemplateLoadSuccessAction,

    IProjectItemTemplateSaveAction,
    IProjectItemTemplateSaveSuccessAction,
    IProjectItemTemplateSaveFailureAction,

    IProjectItemTemplateCreateAction,
    IProjectItemTemplateCreateSuccessAction,
    IProjectItemTemplateCreateFailureAction,

    IProjectItemTemplateValidateAction,
    IProjectItemTemplateValidateSuccessAction,
    IProjectItemTemplateValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/projectItemTemplates";
import { projectItemTemplatesApi } from "../services/projectItemTemplate";


export const
    getProjectItemTemplatesEpic = (action$): Observable<IProjectItemTemplateLoadSuccessAction | IProjectItemTemplateLoadFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEMTEMPLATES_LOAD)
            .mergeMap((action: IProjectItemTemplateLoadAction) => {
                return projectItemTemplatesApi
                    .getProjectItemTemplates(action.projectId)
                    .map(response =>
                        LoadSuccess(response.projectItemTemplates, response.projectItemsByCategory, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getProjectItemTemplateByIdEpic = (action$): Observable<IProjectItemTemplateLoadSuccessAction | IProjectItemTemplateLoadFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEMTEMPLATES_LOAD_BY_ID)
            .mergeMap((action: IProjectItemTemplateLoadByIdAction) => {
                return projectItemTemplatesApi
                    .getProjectItemTemplateById(action.id)
                    .map(response =>
                        LoadSuccess(response.projectItemTemplate, undefined, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setProjectItemTemplateEpic = (action$): Observable<IProjectItemTemplateSaveSuccessAction | IProjectItemTemplateSaveFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEMTEMPLATES_SAVE)
            .mergeMap((action: IProjectItemTemplateSaveAction) => {
                return projectItemTemplatesApi
                    .setProjectItemTemplate(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.projectItemTemplate, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createProjectItemTemplateEpic = (action$): Observable<IProjectItemTemplateCreateSuccessAction | IProjectItemTemplateCreateFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEMTEMPLATES_CREATE)
            .mergeMap((action: IProjectItemTemplateCreateAction) => {
                return projectItemTemplatesApi
                    .createProjectItemTemplate(action.projectId)
                    .map(response =>
                        CreateSuccess(
                            response.projectItemTemplate,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateProjectItemTemplateEpic = (action$): Observable<IProjectItemTemplateValidateSuccessAction | IProjectItemTemplateValidateFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTITEMTEMPLATES_VALIDATE)
            .mergeMap((action: IProjectItemTemplateValidateAction) => {
                return projectItemTemplatesApi
                    .setProjectItemTemplate(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.projectItemTemplate, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



